const PREFIX = '/v1/admin/center'

export const URL = {
  DICTIONARY: PREFIX + '/dictionary',
  MENUS: PREFIX + '/myMenus',
  INFO: PREFIX + '/basic',
  EDIT_INFO: PREFIX + '/updateInfo',
  RESET_PWD: PREFIX + '/resetPasswd',
  MENUS_ALL: PREFIX + '/allMenus',
  WECHAT_UNBIND: PREFIX + '/cancelBindWeChat',
  WECHAT_BIND: PREFIX + '/bindWeChat',
  WECHAT_BIND_CHECK: PREFIX + '/checkBindWeChat',
  EMAIL_BIND: PREFIX + '/bindEmail',
  PHONE_BIND: PREFIX + '/bindPhone'
}
